import { getEnvironment } from '../env/env';
import { fetchRequest } from './FetchRequest';
import { API_VERSION, PATH_AUTH_API } from 'src/constants/api-routes';

interface GoogleTokens {
  access_token?: string;
  [key: string]: unknown;
}

// The SSO login response: the app's tokens, or `{ success: true }` when already signed in.
export interface GoogleSignInResponse {
  access?: string;
  access_token?: string;
  [key: string]: unknown;
}

const ALREADY_AUTHENTICATED = 'User already authenticated!';

const signInWithGoogle = {
  // fetchRequest never rejects, so every failure here comes back as an Error.
  signInWithGoogle: async (code: string): Promise<GoogleSignInResponse | Error> => {
    const environment = await getEnvironment();
    const getTokenURL = `https://oauth2.googleapis.com/token`;
    const data = {
      code: decodeURIComponent(code),
      client_id: environment.APP_GOOGLE_OAUTH_CLIENT_ID,
      client_secret: environment.APP_GOOGLE_OAUTH_CLIENT_SECRET,
      redirect_uri: decodeURIComponent(environment.APP_REDIRECT_URI),
      access_type: 'offline',
      grant_type: 'authorization_code',
    };

    const tokens = await fetchRequest<GoogleTokens>('POST', getTokenURL, data);

    if (tokens instanceof Error) {
      return tokens;
    }

    if (tokens === true || !tokens.access_token) {
      return new Error('Google returned no access token');
    }

    localStorage.setItem('tokens', JSON.stringify(tokens));

    const loginResult = await fetchRequest<GoogleSignInResponse>(
      'POST',
      `${environment.APP_SSO_BASE_URL}/${API_VERSION.V1}/${PATH_AUTH_API.TOKEN_GOOGLE}`,
      {
        token: tokens.access_token,
      },
    );

    if (loginResult instanceof Error && loginResult.message.includes(ALREADY_AUTHENTICATED)) {
      return { success: true };
    }

    if (loginResult instanceof Error || loginResult === true) {
      localStorage.removeItem('tokens');
      return loginResult === true ? new Error('Sign-in returned no tokens') : loginResult;
    }

    return loginResult;
  },
};

export { signInWithGoogle };
